import { List, Map, fromJS } from 'immutable';
import { get, set } from 'lodash';

export function request(state, { id }) {
    id = parseInt(id, 10);

    const counters = state.get('counters') || Map();
    let user = counters.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state.set('counters', counters.set(id, user));
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    const counters = state.get('counters') || Map();
    let user = counters.get(id) || Map();

    user = user
        .set('list', List())
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set('counters', counters.set(id, user));
}

export function finish(state, { id, data }) {
    id = parseInt(id, 10);
    const counters = state.get('counters') || Map();
    let user = counters.get(id) || Map();

    let newData = data;
    const casino_bets = get(data, 'casino-bets.*');
    const casino_operator_profits = get(data, 'casino-operator-profits.*');
    const casino_operator_turnover = get(data, 'casino-operator-turnover.*');
    const casino_profits = get(data, 'casino-profits.*');
    const casino_turnover = get(data, 'casino-turnover.*');

    if ( casino_bets ) {
        newData = set(newData, 'bets.casino.casino', casino_bets);
        newData = set(newData, 'operator-profits.casino.casino', casino_operator_profits);
        newData = set(newData, 'operator-turnover.casino.casino', casino_operator_turnover);
        newData = set(newData, 'profits.casino.casino', casino_profits);
        newData = set(newData, 'turnover.casino.casino', casino_turnover);

        delete newData['casino-bets'];
        delete newData['casino-operator-profits'];
        delete newData['casino-operator-turnover'];
        delete newData['casino-profits'];
        delete newData['casino-turnover'];
    }

    const virtualsports_bets = get(data, 'virtualsports-bets.*');
    const virtualsports_operator_profits = get(data, 'virtualsports-operator-profits.*');
    const virtualsports_operator_turnover = get(data, 'virtualsports-operator-turnover.*');
    const virtualsports_profits = get(data, 'virtualsports-profits.*');
    const virtualsports_turnover = get(data, 'virtualsports-turnover.*');

    if (virtualsports_bets) {
        newData = set(newData, 'bets.virtualsports.virtualsports', virtualsports_bets);
        newData = set(newData, 'operator-profits.virtualsports.virtualsports', -virtualsports_operator_profits);
        newData = set(newData, 'operator-turnover.virtualsports.virtualsports', virtualsports_operator_turnover);
        /*
            - virtualsports_profits returns data from operator's perspective
            - casino-profits returns data from customer perspective
            Temporary change: Added minus '-' sign to virtualsports_profits. Related to tasks: [SP-3147, SP-3167, SP-3168]
        */
        newData = set(newData, 'profits.virtualsports.virtualsports', -virtualsports_profits);
        newData = set(newData, 'turnover.virtualsports.virtualsports', virtualsports_turnover);

        delete newData['virtualsports-bets'];
        delete newData['virtualsports-operator-profits'];
        delete newData['virtualsports-operator-turnover'];
        delete newData['virtualsports-profits'];
        delete newData['virtualsports-turnover'];
    }

    const livecasino_bets = get(data, 'livecasino-bets.*');
    const livecasino_operator_profits = get(data, 'livecasino-operator-profit.*');
    const livecasino_operator_turnover = get(data, 'livecasino-operator-turnover.*');
    const livecasino_profits = get(data, 'livecasino-profit.*');
    const livecasino_turnover = get(data, 'livecasino-turnover.*');

    if (livecasino_bets) {
        newData = set(newData, 'bets.livecasino.livecasino', livecasino_bets);
        newData = set(newData, 'operator-profits.livecasino.livecasino', livecasino_operator_profits);
        newData = set(newData, 'operator-turnover.livecasino.livecasino', livecasino_operator_turnover);
        newData = set(newData, 'profits.livecasino.livecasino', livecasino_profits);
        newData = set(newData, 'turnover.livecasino.livecasino', livecasino_turnover);

        delete newData['livecasino-bets'];
        delete newData['livecasino-operator-profit'];
        delete newData['livecasino-operator-turnover'];
        delete newData['livecasino-profits'];
        delete newData['livecasino-turnover'];
    }

    user = user
        .set('list', fromJS(newData))
        .set('state', 'FINISHED')
        .set('errors', void 0);

    return state.set('counters', counters.set(id, user));
}

export function clear(state) {
    return state.set('counters', Map());
}
